export default class Progress {
	constructor() {
		this.view = null;
	}

	handle(view) {
		this.view = view;
	}

	start() {
		const view = this.view;
		if (!view || view.$destructed) return;
		view.showBatch("saving");
		if (this._progressDelay) clearTimeout(this._progressDelay);
		this._progressDelay = window.setTimeout(() => {
			if (!view || view.$destructed) return;
			this.end();
		}, 3000);
	}

	end() {
		const view = this.view;
		if (!view || view.$destructed) return;
		view.showBatch("saved");
		if (this._progressDelay) clearTimeout(this._progressDelay);
		if (this._hideDelay) clearTimeout(this._hideDelay);
		this._hideDelay = window.setTimeout(() => {
			if (!view || view.$destructed) return;
			view.showBatch("def");
		}, 3000);
	}
}
